function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    info\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.45,30.4a10.26,10.26,0,0,1,.42-2.64l2-7.48H10.11L11.22,15H24.73L21.59,28a4,4,0,0,0-.17,1,2,2,0,0,0,2.29,2.21,8,8,0,0,0,3.06-.77l1.36,5.1a16.26,16.26,0,0,1-6.54,1.19C17.25,36.77,14.45,34.31,14.45,30.4ZM17.59,8.33a4.65,4.65,0,0,1,4.76-4.46c2.43,0,4.21,1.28,4.21,3.7A4.57,4.57,0,0,1,21.76,12C19.63,12,17.59,10.84,17.59,8.33Z",
  fill: "#727475"
});

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgInfo;